<template>
    <div class="sitepanel" v-if="stationConfig">
        <div class="setting-label-wrap" @mouseenter="toggleSiteLabelShow" @mouseleave="toggleSiteLabelShow">
            <!--标签显示隐藏-->
            <div id="btn-setting-label" :class="['btn-setting btn-setting-label', sitesShowflag?'selected':'']" >
                <img class="btn-img all" src="../../assets/img/btn-show.png" v-if="sitesShowflag" @click="stationAllShow">
                <img class="btn-img all" src="../../assets/img/btn-hide.png" v-else @click="stationAllShow">
            </div>
            
            <!--站点类型显示标签-->
            <div class="label-subitem" v-if="stationConfig" v-show="sitesLabelflag">
                <span v-for="(item,index) in stationConfig.show" :key="index" :class="[item.isCheck ? 'selected' : '', 'item']" :data-name="item.itemName" :data-index="index" @click="stationTypeSwitch(item)">
                    {{item.name}}
                </span>
            </div>
        </div>


        <!--测点数据配置弹框-->
        <div id="btn-setting-site" class="btn-setting btn-setting-site" @click="siteStyleSettings">
            <img src="../../assets/img/btn-setting-site.png" class="all">
        </div>

        <!--站点属性配置面板-->
        <el-dialog
            :visible.sync="siteStyleDialog"
            width="30%"
            :append-to-body="true"
            :show-close="false"
            custom-class="station-wrapper"
            center
            :before-close="styleFunctionClose">
            <div class="setting-conent">
                <div style="font-size: 15px;color:#5B5B5B;margin-top: 5px">
                    面板字体大小
                </div>
                <div class="style-wrap setting-item" v-if="tempShowFont">
                    <el-input-number v-model="tempShowFont" :min="12" label="设置字体大小"></el-input-number>
                </div>

                <div style="font-size: 15px;color:#5B5B5B;margin-top: 5px">
                    显示风格
                </div>
                <div class="style-wrap setting-item" v-if="tempShowStyle">
                    <div v-for="(item,index) in tempShowStyle" :key="index" :data-value="item.itemName" 
                        :class="['item',item.isCheck?'selected':'']" @click="stationStyleShow(item)">
                        {{item.name}}
                    </div>
                </div>

                <div style="font-size: 15px;color:#5B5B5B;margin-top: 5px">
                    介质类型
                </div>
                <div class="medium-wrap setting-item" v-if="tempShowMedium">
                    <div v-for="(item,index) in tempShowMedium" :key="index" :data-value="item.itemName"
                        :class="['item',(item.itemName==selectMedium.itemName)?'selected':'']" @click="selectedMediumSwitch(item)">
                        {{item.name}}
                    </div>
                </div>

                <div style="font-size: 15px;color:#5B5B5B;margin-top: 5px">
                    介质的属性
                    <span class="current-medium" v-if="selectMedium">({{selectMedium.name}})</span>
                </div>

                <div class="parameter-wrap setting-item" v-if="selectMedium">
                    <div v-for="(item,index) in selectMedium.subitem" :key="index" data-value="item.itemName"
                        :class="['item',item.isCheck?'selected':'']" @click="mediumPropertiesSwitch(item)">
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div style="display: flex;flex-direction: row;" class="btn-array" slot="footer">
                <el-button class="btn btn-canel" @click="styleFunctionCancel">取消</el-button>
                <el-button class="btn btn-ok" @click="styleFunctionOk">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getStationLayer,getFactoryLayer,getStationTimingData,setUserSetting} from "@api/map2d";

import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import _debounce from 'lodash/debounce'; // 函数防抖，避免多次调用

/** 站点属性面板 */
export default {
    name:"sitepanel",
    props:["mainmap","stationConfig"],
    data(){
        return {
            // stationConfig:null, // 站点配置内容
            sitesShowflag:false, // 站点类型开关状态，眼睛的打开与关闭
            sitesLabelflag:false, // 站点类型标签的状态，站点选择的打开与关闭

            siteStyleDialog:false, // 站点风格设置对话框
            tempShowStyle:null, // 临时站点风格的配置
            tempShowMedium:null, // 临时站点介质的显示配置
            tempShowFont:null, // 临时的字体及其配置
            
            selectMedium:null, // 当前选中的介质类型

            sitesPanels:[], // 站点属性面板

            stationFeatureArray:null, // 站点图层
            overlayLineLayer:null, // 属性框和站点之间的连线图层

            stationTimer:null, // 站点的实时数据定时器ID
            mapComplete:false, //地图是否渲染完成
        }
    },
    computed:{
        db(){
            return this.$store.getters.db;
        }
    },
    watch:{
        stationConfig:{
            handler:function(newValue){
                let patternName=newValue.pattern.name;
                // let patternOName=oldValue.pattern.name;
                // 只有当从模拟状态切换为实时状态时，才重启定时器
                if(patternName=="realtime"){

                    // 获取站点的实时数据
                    this.getStationTimingData();
                    // 重启定时器
                    this.getStationTiming();
                }
            },
            deep:true
        },
        /** 监听数据库改变 */
        db:{
            handler:function(){
               // 重新执行初始化工作
               // this.init_config();
            },
            deep:true
        }
    },
    mounted(){
        // 获取站点图层
        this.getStationLayer();
        // 获取站点属性配置信息
        this.getUserSetting();

        // 获取厂区数据
        this.getFactoryLayer();
    },
    methods:{
        // 获取站点图层
        async getStationLayer(){
            await getStationLayer().then(data=>{
                let that=this;
                // 判断是否数据正常
                if(data&&data.status&&data.status==500){
                    return
                }
                let geojsonFormat=new GeoJSON();
                let features=geojsonFormat.readFeatures(data);

                //绘制图层
                let vectorSource = new VectorSource({
                    name:"station_source",
                    format: new GeoJSON(),
                });
                vectorSource.addFeatures(features);
                let vector = new VectorLayer({
                    source: vectorSource,
                    name:"station_layer",
                    zIndex:20,
                    minResolution:that.mainmap.getResolution(20),
                    maxResolution:that.mainmap.getResolution(12),
                    style:that.stationStyle
                });
                that.mainmap.addLayer(vector);

                 // 添加连线图层
                vectorSource = new VectorSource({
                    name:"overlayLineLayer_source",
                });
                vector = new VectorLayer({
                    source: vectorSource,
                    name:"overlayLineLayer_layer",
                    zIndex:15,
                    minResolution:that.mainmap.getResolution(20),
                    maxResolution:that.mainmap.getResolution(12),
                    style:new Style({
                        fill: new Fill({
                            color: '#d7ad50cc'
                        }),
                        stroke: new Stroke({
                            lineDash:[1,2,3,4,5,6],
                            color: '#d7ad50cc',
                            width: 4
                        })
                    })
                });
                that.mainmap.addLayer(vector);
                that.overlayLineLayer=vector;

                // 图层配置信息
                let layerConfig=that.stationConfig.layer||{};
                //设置站点的id号
                for(let i=features.length-1;i>=0;i--){
                    let feature=features[i];
                    let properties=feature.getProperties();
                    let id=properties.id;
                    feature.setId(id);
                    feature.set("layer","station");
                    // 设置属性信息
                    let featureConfig=layerConfig[id];
                    if(featureConfig){
                        feature.setProperties(featureConfig);
                    }
                }

                //将请求结果保存在stationFeatureArray对象中
                that.stationFeatureArray=features;
            });
            // 绘制连线图层
            this.showOverlayLine();
        },
        // 获取厂区图层数据
        getFactoryLayer(){
            let that=this;
            getFactoryLayer().then(data=>{
                // 判断是否数据正常
                     if(data&&data.status&&data.status==500){
                        return
                    }
                    let geojsonFormat=new GeoJSON();
                    let features=geojsonFormat.readFeatures(data);

                    //绘制图层
                    let vectorSource = new VectorSource({
                        format: new GeoJSON(),
                    });
                    vectorSource.addFeatures(features);
                    // 设置id号
                    let coutF=features.length;
                    for(let i=coutF-1;i>=0;i--){
                        let feature=features[i];
                        let properties=feature.getProperties();
                        feature.setId(properties.id);
                    }

                    let vector = new VectorLayer({
                        name:"factory_layer",
                        source: vectorSource,
                        zIndex:12,
                        minResolution:that.mainmap.getResolution(20),
                        maxResolution:that.mainmap.getResolution(12),
                        style:that.factoryStyleFunction
                    });
                    that.mainmap.addLayer(vector);
            })
        },
        //厂区的样式
        factoryStyleFunction:function(feature){
            let properties=feature.getProperties();

            //根据相应站点的流量绘制颜色             
            let rgb=null;
            
            //根据厂区编号获取站点
            // let realData=feature.get("realdata");
            // 如果存在实时数据，则根据实时数据绘制厂区颜色
            // if(realData){
            //     //根据当前色卡配置选择执行单色卡绘制还是双色卡数值
            //     let r=GIS.factoryRgb;
            //     // 获取当前属性
            //     let currentValue=realData.SumFlux;
            //     rgb=r.getCurrentColor(currentValue);
            // }
            if(!rgb){
                rgb="rgba(0, 229, 255,0.7)";
            }else{
                rgb=rgb.substring(0,rgb.length-1)+",0.6)";
            }
            // 根据分辨率调整文字大小
            let level=Math.floor(this.mainmap.getView().getZoom());           

            let style=new Style({
                stroke: new Stroke({
                    width:1,
                    color:"#aaa"
                }),
                fill:new Fill({
                    color:rgb
                }),
                text:new Text({ 
                    font:(level)+"px sans-serif",
                    text:properties.name,
                    fill:new Fill({
                        color:"#eee"
                    })
                })
            });
            return style;
        },
        // 配置站点样式
        stationStyle:function(feature){
            let properties=feature.getProperties();
            let type=properties.type||"virtual"; // 站点图标类型
            let label=properties.label||0;// 站点图标的旋转方向
            let src=this.$store.state.assetsUrl+"/img/sites/"+type+"-"+label+".png";

            // 设置图标的样式
            let iconStyle = new Style({
                image: new Icon({
                    src: src,
                    scale:0.8,
                    anchor:[0.5,1],
                    rotation:label/180*Math.PI
                })
            });
            return iconStyle;
        },
        // 获取站点配置信息
        getUserSetting(){
            // this.tempShowStyle=Object.assign({},this.stationConfig.style); // 保存临时的站点风格展示属性，为了在取消时返回之前的值
            // this.tempShowMedium=Object.assign({},this.stationConfig.medium);// 保存临时的站点介质，为了在取消时返回之前的值
            try{
                this.tempShowStyle=JSON.parse(JSON.stringify(this.stationConfig.style)); // 保存临时的站点风格展示属性，为了在取消时返回之前的值
                this.tempShowMedium=JSON.parse(JSON.stringify(this.stationConfig.medium));// 保存临时的站点介质，为了在取消时返回之前的值
            }catch(err){
                console.log("error:getUserSetting");
            }


            this.tempShowFont=this.stationConfig.font||12;// 保存临时的字体配置，为了在取消时返回之前的值

            // 设置当前选中的介质及其属性
            this.selectMedium=this.tempShowMedium[0];

            // 获取站点的实时数据
            this.getStationTimingData();
            // 启动定时器
            this.getStationTiming();
        },
        // 全部站点类型的显示和隐藏
        stationAllShow(){
            // 如果当前全部显示
            let showArray=this.stationConfig.show;
            let showCount=showArray.length;
            if(this.sitesShowflag){
                for(let i=0;i<showCount;i++){
                    let tempLabel=showArray[i];
                    tempLabel.isCheck=false;
                }
                // 关闭站点
                this.sitesShowflag=false;
            }else{
                for(let i=0;i<showCount;i++){
                    let tempLabel=showArray[i];
                    tempLabel.isCheck=true;
                }
                // 关闭站点
                this.sitesShowflag=true;
            }

            // 重新绘制站点属性面板
            this.stationPropertyShow();
        },

        // 站点类型的显示于隐藏
        stationTypeSwitch(item){
            item.isCheck=!item.isCheck;

            // 重新绘制站点属性面板
            this.stationPropertyShow();
        },

        // 站点标签的显示和隐藏
        toggleSiteLabelShow(){
            this.sitesLabelflag = !this.sitesLabelflag
        },

        // 站点风格设置对话框的显示于隐藏
        siteStyleSettings(){
            this.siteStyleDialog=true;
        },
        // 站点风格的设置,显示单位，颜色以及名称等
        stationStyleShow(item){
            item.isCheck=!item.isCheck;
        },
        // 切换选中的介质类型，设置相应介质的显示的字段内容
        selectedMediumSwitch(item){
            this.selectMedium=item;
        },
        // 选中的介质类型的属性显示与隐藏
        mediumPropertiesSwitch(item){
            item.isCheck=!item.isCheck;
        },
        // 站点风格设置对话框关闭
        styleFunctionClose(){
            this.siteStyleDialog=false; // 站点设置对话框关闭
            // 还原相应的操作
            this.tempShowStyle=JSON.parse(JSON.stringify(this.stationConfig.style)); // 保存临时的站点风格展示属性，为了在取消时返回之前的值
            this.tempShowMedium=JSON.parse(JSON.stringify(this.stationConfig.medium));// 保存临时的站点介质，为了在取消时返回之前的值        
        },
        // 站点风格设置对话框取消
        styleFunctionCancel(){
            // 判断字体大小是否修改
            let tempFont=this.tempShowFont;
            let tempFontOri=this.stationConfig.font||12;            

            // 判断介质是否修改
            let tempMedium=JSON.stringify(this.tempShowMedium);
            let tempMediumOri=JSON.stringify(this.stationConfig.medium);
            // console.log(tempMedium);
            // console.log(tempMediumOri);

            // 判断风格是否修改
            let tempStyle=JSON.stringify(this.tempShowStyle);
            let tempStyleOri=JSON.stringify(this.stationConfig.style);

            // 当有任何一处改变的时候，弹出提示框
            if(tempFont!=tempFontOri||tempMedium!=tempMediumOri||tempStyle!=tempStyleOri){
                this.$confirm('您的操作还没有保存, 是否继续修改?', '温馨提示', {
                    confirmButtonText: '继续修改',
                    cancelButtonText: '确定取消',
                    type: 'warning'
                }).catch(() => {
                    this.siteStyleDialog=false; // 站点设置对话框关闭
                    // 还原相应的操作
                    this.tempShowStyle=JSON.parse(JSON.stringify(this.stationConfig.style)); // 保存临时的站点风格展示属性，为了在取消时返回之前的值
                    this.tempShowMedium=JSON.parse(JSON.stringify(this.stationConfig.medium));// 保存临时的站点介质，为了在取消时返回之前的值
                    this.tempShowFont=this.stationConfig.font||12;// 保存临时的站点介质，为了在取消时返回之前的值
                    
                });
            }else{
                this.siteStyleDialog=false; // 站点设置对话框关闭
            }            
        },
        // 站点风格设置对话框确定
        styleFunctionOk(){
            this.stationConfig.style=this.tempShowStyle; // 保存站点样式修改
            this.stationConfig.medium=this.tempShowMedium; // 保存介质字段显示修改
            this.stationConfig.font=this.tempShowFont; // 保存介质的字段配置

            // 重新绘制站点属性面板
            this.stationPropertyShow();

            // 关闭对话框
            this.siteStyleDialog=false;

            // 将用户设置保存到远程服务器
            setUserSetting("station",JSON.stringify(this.stationConfig)).then(data=>{
                if(data.status&&data.status==200){
                    this.$message({
                        message:"用户配置保存成功",
                        type:"success"
                    })
                }
            })
        },
          //定时获取站点实时数据
        getStationTiming:function(){
            let that=this;
            // 清空定时器
            if(that.stationTimer){
                clearTimeout(that.stationTimer);
                that.stationTimer=null;
            }
            // 判断当前路由是否为智慧管网，如果不是，则应该取消定时器
            if(this.$route.name!="mapShow"){
                // 清空定时器
                if(that.stationTimer){
                    clearTimeout(that.stationTimer);
                    that.stationTimer=null;
                }
                return;
            }
            // 设置新的定时器
            if(!that.stationTimer){
                that.stationTimer=setTimeout(function () {
                    if(that.stationConfig&&that.stationConfig.pattern){
                        let patternName=that.stationConfig.pattern.name;
                        if(patternName=="realtime"){
                            //执行获取站点实时数据以及绘制的代码
                            that.getStationTimingData();

                            // 重启定时器
                            that.getStationTiming();
                        }else {
                            clearTimeout(that.stationTimer);
                            that.stationTimer=null;
                        }
                    }
                },30*1000);
            }
        },

        // 获取站点数据的实时数据
        getStationTimingData(){
            let that=this;
            // 判断当前路由是否为地图页面，如果不是，则应该取消定时器
            if(this.$route.name!="mapShow"){
                // 清空定时器
                if(that.stationTimer){
                    clearTimeout(that.stationTimer);
                    that.stationTimer=null;
                }
                return;
            }
            // 进行数据请求，获取实时数据
            getStationTimingData().then(async data=>{
                this.sitesPanels=data;
                // 站点图层
                let stationLayer=that.mainmap.getLayerByName("station_layer");
                // 如果站点图层没有,则重新构建请求，并进行更新
                if(!stationLayer){
                    await this.getStationLayer();
                    stationLayer=that.mainmap.getLayerByName("station_layer");
                }
                // 如果站点图层未定义
                if(!stationLayer){
                    // 清除定时器
                    if(that.stationTimer){
                        clearTimeout(that.stationTimer);
                        that.stationTimer=null;
                    }
                    return;
                }
                // 站点图层
                let source=stationLayer.getSource();

                // 厂区图层
                let factory=that.mainmap.getLayerByName("factory_layer");
                let factorySource=null;
                if(factory){
                    factorySource=factory.getSource();
                }

                let maxSumFlux=-Infinity;
                let minSumFlux=Infinity;
                // 将站点的时候数据绑定到Feautre上
                this.stationFeatureArray=[];
                for(let i=data.length-1;i>=0;i--){
                    let realData=data[i];
                    // 获取图上的Feature
                    let feature=source.getFeatureById(realData.SiteNo);
                    if(feature){
                        feature.set("realdata",realData); // 绑定实时数据
                        this.stationFeatureArray.push(feature);// 更新站点数组
                    }

                    //将站点实时数据绑定到厂区
                    if(factorySource){
                        let factoryFeature=factorySource.getFeatureById(realData.SiteNo);
                        if(factoryFeature){
                            factoryFeature.set("realdata",realData);
                        }
                    }
                    //获取流量计的最大最小值
                    if(realData.SumFlux>maxSumFlux){
                        maxSumFlux=realData.SumFlux;
                    }
                    if(realData.SumFlux<minSumFlux){
                        minSumFlux=realData.SumFlux;
                    }
                } 

                // 显示站点属性
                this.stationPropertyShow();

            });
        },

        // 计算dom的缩放比
        detectZoom(){
            let ratio = 0,
            screen = window.screen,
            ua = navigator.userAgent.toLowerCase();
            if (window.devicePixelRatio !== undefined) {
                ratio = window.devicePixelRatio;
            }
            else if (~ua.indexOf('msie')) {
                if (screen.deviceXDPI && screen.logicalXDPI) {
                    ratio = screen.deviceXDPI / screen.logicalXDPI;
                }
            }
            else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                ratio = window.outerWidth / window.innerWidth;
            }

            if (ratio) {
                ratio = Math.round(ratio * 100);
            }
            ratio=ratio/100;
            if(ratio>1){
                ratio=1;
            }
            return ratio;
        },

        //站点配置的属性表显示
        stationPropertyShow:function(){
            // let that=this;
            // 属性框显示的最小级别
            let propertiesZoom=12;
            //获取地图级别，地图级别过小，不显示
            let zoom=this.mainmap.getView().getZoom();

            //关闭其他的显示的属性框
            let overlays=this.mainmap.getOverlays();
            overlays.forEach(function(item){
                if(item.getId()!="pipelineproperty"){ // 如果不是属性面板，则不进行关闭
                    item.setPosition(undefined);
                }
            });
            
            if(!this.overlayLineLayer){
                console.log("连线图层未定义");
                return;
            }
            // 清空指向线图层
            this.overlayLineLayer.getSource().clear();

            // 获取当前的站点配置
            let stationConfig=this.stationConfig;
            if(!stationConfig){
                return;
            }

            //获取站点类型是否显示
            let showConfig=this.stationConfig.show;
            let showFiled="";
            for(let i=showConfig.length-1;i>=0;i--){
                let temp=showConfig[i];
                if(temp.isCheck){
                    showFiled+=temp.itemName;
                }
            }

            //遍历所有的站点数据，为每一个站点显示相关的内容
            let features=this.stationFeatureArray;

            //遍历站点配置，获取介质及其对应的数组编号
            let mediumObj={};
            let mediumArray=stationConfig.medium;
            //介质的索引表
            for(let i=mediumArray.length-1;i>=0;i--){
                let tempMedium=mediumArray[i];
                mediumObj[tempMedium.itemName]=tempMedium;
            }

            //风格的索引表
            let styleObj={};
            let styleArray=stationConfig.style;
            for(let i=styleArray.length-1;i>=0;i--){
                let temp=styleArray[i];
                styleObj[temp.itemName]=temp;
            }

            let station_show=stationConfig.station_show; // 单独站点显示属性的配置

            //获取缩放比率
            let ratio=this.detectZoom();

            // 获取字体大小,默认为12px
            let fontSize=stationConfig.font||12;

            // 添加属性显示，采用overlay性能不太好，如果是超过3000，超过一万?
            for(let i=features.length-1;i>=0;i--){
                let feature=features[i];
                let featureProperties=feature.getProperties();//属性数据

                let realData=featureProperties.realdata; //实时数据
                //如果没有实时数据对应，则不显示属性框
                if(!realData){
                    console.log("实时数据不存在");
                    continue;
                }

                //属性框显示
                let overlay=this.mainmap.getOverlayById("station_"+featureProperties.id);
                let overlayDom=null;

                let SiteName=featureProperties.name||realData.SiteName||realData.SiteNo||""; //站点名称
                if(!overlay){
                    // 插入body中
                    overlayDom=document.createElement("div");
                    overlayDom.id="station_"+featureProperties.id;
                    overlayDom.className="ztOverlay station station_"+featureProperties.id+" "+featureProperties.type;
                    overlayDom.dataset.number=featureProperties.id;
                    overlayDom.dataset.medium=featureProperties.medium;

                    let innerHTML="<div class='zt-title'>" +
                            "<span>"+realData.SiteNo+("&lt;"+SiteName+"&gt;")+"</span>"+
                        "</div>"+
                        "<ul class='ztOverlay_content'></ul>";
                    overlayDom.innerHTML=innerHTML;

                    // 加入DOM树
                    // document.body.appendChild(overlayDom);

                    // 创建overlayer
                    overlay = new Overlay({
                        id:"station_"+featureProperties.id,
                        element: overlayDom,
                        // positioning:featureProperties.anchor,
                        stopEvent:true,
                        dragging: false,
                        className:"ztOverlayWarp"
                        // position:feature.getGeometry().getCoordinates(),
                    });
                    this.mainmap.addOverlay(overlay);
                }else {
                    overlayDom=overlay.getElement();
                }
                //根据缩放比例进行全局缩放
                overlayDom.style.transform="scale("+ratio+")";

                // 设置字体大小
                overlayDom.style.fontSize=fontSize+"px";
                // 设置标题的字体大小,比内容的字体大两号
                let titleDom=overlayDom.querySelector(".zt-title");
                titleDom.style.fontSize=fontSize+2+"px";

                // 清除Dom引用
                titleDom=null;

                // 获取站点类型，然后根据站点类型决定显示哪些项目，蒸汽，电，水，空气不一样，
                // 然后在显示的项目类型中，再根据显示风格进行切换
                // 默认的就是steam蒸汽
                let medium=featureProperties.medium||"steam";

                let featureMedium=mediumObj[medium];
                if(!featureMedium){
                    console.log("介质类型未定义");
                    continue;
                }
                let subItem=featureMedium.subitem; // 介质的中英文对照表
                
                let ztItemhtml="";
                let subCount=subItem.length;

                let filedWidth=0; //字段的宽度
                let dataWidth=0; // 数字的宽度
                let unitWidth=0; // 单位的宽度
                let fontRatio=fontSize/12; // 求字体大小影响的宽度

                // 生成站点的数据显示面板
                for(let j=0;j<subCount;j++){
                    let tempSub=subItem[j];

                    // 显示计算值(理论值)
                    let pipeline_string="";
                   
                    //如果选中了相应字段，则显示，如果没有选中，则不显示
                    if(tempSub.isCheck&&(realData[tempSub.itemName]||realData[tempSub.itemName]==0)){
                        // 如果定义了特殊的站点显示属性，则以站点显示属性配置为准
                        let station_s=station_show[featureProperties.id];
                        if(station_s){
                            // 如果不在特殊配置中的属性，则不显示
                            if(station_s.indexOf(tempSub.itemName)<0){
                                continue;
                            }
                        }

                        let color=styleObj["color"].isCheck?tempSub.color:"rgb(0,0,0)";

                        // 变态需求，根据字符个数，设置单位下显示宽度，不能定死，不能两端对齐
                        let tempSubLength=tempSub.name.length||1;

                        let filed=styleObj["filed"].isCheck?("<div class='filedname'>"+tempSub.name+"</div>:  "):""; // 字段的中文
                        // 如果中文字段存在
                        if(filed){
                            // 中文说明的宽度
                            if(filedWidth<=tempSubLength*12*fontRatio){
                                filedWidth=tempSubLength*12*fontRatio;
                            }
                        }


                        let unit=styleObj["unit"].isCheck?tempSub.unit:"";

                        // 当前的实时数据
                        let dataValue=realData[tempSub.itemName].toString();
                        

                        // 如果当前站点编号大于100,则只显示温度和压力、差压和瞬时流量
                        // if(realData.SiteNo&&realData.SiteNo>100){
                        //     if(tempSub.itemName=="Tempe"||tempSub.itemName=="Press"||tempSub.itemName=="RecordTime"){
                        //         // 显示必要的属性
                        //         ztItemhtml+="<li class='item "+tempSub.itemName+"' data-name='"+tempSub.itemName+"' style='color:"+color+";'>"+(filed)+dataValue+" "+(unit)+pipeline_string+"</li>";
                        //     }
                        // }else{// 显示剩余的属性

                            // 如果真实数据为小数，则最多显示3位小数
                            if(dataValue.indexOf(".")>0){
                                let dataLength=dataValue.split(".")[1].length;
                                if(dataLength>3){
                                    dataValue=parseFloat(dataValue).toFixed(3);
                                }
                            }

                            // 时间单独处理，进行换行
                            let dataValueHtml=dataValue;
                            if(tempSub.itemName=="RecordTime"){
                                let temp=dataValue;
                                let tempDate=this.$moment(temp).format("YY-MM-DD");
                                let tempTime=this.$moment(temp).format("HH:mm:ss");
                                // 配置html
                                dataValueHtml=
                                    `
                                    <div class="datavalue">
                                        <div>${tempDate}</div>
                                        <div>${tempTime}</div>
                                    </div>
                                    `;
                                // 保留格式化后的值
                                dataValue=tempDate;
                            }else{
                                // 判断是否有理论值,显示站点的理论计算值
                                if(realData.pipeline_data){
                                    let pipeData=realData.pipeline_data;
                                    let v=pipeData[tempSub.itemName];
                                    if(v){
                                        dataValueHtml=
                                        `
                                            <div class="datavalue">
                                                <div>${dataValue} ${unit}</div>
                                                <div style='color:red;'>(理:${v.toFixed(4)} ${unit})</div>
                                            </div>
                                        `;
                                        // pipeline_string="<span style='color:red;'> (理:"+v.toFixed(4)+" "+(unit)+")</span>";
                                    }else{
                                        dataValueHtml="<div class='datavalue'>"+dataValue+" "+(unit)+"</div>";
                                    }
                                }else{
                                    dataValueHtml="<div class='datavalue'>"+dataValue+" "+(unit)+"</div>";
                                }
                            }

                            ztItemhtml+="<li class='item "+tempSub.itemName+"' data-name='"+tempSub.itemName+"' style='color:"+color+";'>"+(filed)+dataValueHtml+"</li>";
                        // }

                        //计算整个数据的宽度
                        // let valNumber=(realData[tempSub.itemName]+"").length||1;
                        let valNumber=(dataValue+"").length||1;

                        // 理论值
                        if(pipeline_string){
                            valNumber+=17;
                        }
                    
                        // 计算数据的宽度
                        if(dataWidth<=valNumber*8*fontRatio){
                            dataWidth=valNumber*8*fontRatio;
                        }

                        //计算单位的宽度
                        let unitNumber=unit.length||2;
                        if(unitWidth<=unitNumber*9*fontRatio){
                            unitWidth=unitNumber*9*fontRatio;
                        }
                    }

                }

                //添加字段到显示面板
                overlayDom.querySelector(".ztOverlay_content").innerHTML=ztItemhtml;
                // 设置全部字段名的样式
                let filedNameArray=overlayDom.querySelectorAll(".filedname");
                if(filedNameArray.length>0){
                    filedNameArray.forEach(item=>{
                        item.style.width=filedWidth+"px";
                    });
                }
                // 清除Dom引用
                filedNameArray=null;

                //设置面板的宽度
                overlayDom.style.minWidth=dataWidth+filedWidth+unitWidth+"px";

                //设置偏移量,为了应付奇葩需求，只能动态计算缩放比例，然后重新设置相应的overlay位置了
                // 如果执行了屏幕缩放，就要计算相应的缩放量，然后将offset相应的前去缩放量的一半，这样基本上可以进行相应位置的定位不变
                // 左上角还是左上角，右下角还是右下角
                let domWidth=parseInt(overlayDom.style.width)||0;
                let domHeight=parseInt(overlayDom.style.height)||0;
                let offsetWidth=domWidth*ratio/2;
                let offsetHeight=domHeight*ratio/2;
                let offset=[0,0];

                // 面板的位置,底部的中间
                let anchor=featureProperties.anchor||"bottom-center";

                // if(featureProperties.id==14){
                //     console.log(anchor);
                // }
                switch (anchor) {
                    case "bottom-left":
                        offset=[10-offsetWidth,-10+offsetHeight];
                        break;
                    case "bottom-center":
                        offset=[0,-40+offsetHeight];
                        break;
                    case "bottom-right":
                        offset=[-15+offsetWidth,-20+offsetHeight];
                        break;
                    case "center-left":
                        offset=[10-offsetWidth,0];
                        break;
                    case "center-right":
                        offset=[-10+offsetWidth,0];
                        break;
                    case "top-left":
                        offset=[15-offsetWidth,20-offsetHeight];
                        break;
                    case "top-center":
                        offset=[0,40-offsetHeight];
                        break;
                    case "top-right":
                        offset=[-15+offsetWidth,20-offsetHeight];
                        break;
                    // 如果anchor不存在
                    default:
                        featureProperties.anchor="center-center"
                        offset=[0,0];
                        break;
                }
                // 设置label的偏移量
                overlay.setOffset(offset);
                
                let stationType=featureProperties.type||"site";
                let stationGeom=feature.getGeometry();
                let stationCoordinate=stationGeom.getCoordinates(); // 站点坐标
                overlay.set("stationCoordinate",stationCoordinate); // 保存站点坐标

                let map=this.mainmap;
                let that=this;
                let linesource=this.overlayLineLayer.getSource(); // 属性与图标的连线图层
                // 删除已有连线
                let fid="line"+feature.get("id");
                let lineFeature=linesource.getFeatureById(fid);
                // console.log(lineFeature);
                if(lineFeature){
                    linesource.removeFeature(lineFeature);
                    overlay.set("line",null);
                }

                // 控制属性的显示和隐藏,站点配置项中是否显示属性、以及显示哪些类型的站点和地图级别是否达到了显示要求
                // 未定义，则默认是site
                if(stationConfig.show&&zoom>=propertiesZoom&&showFiled.indexOf(stationType)>=0){
                    //计算lebal位置
                    overlay.setPositioning(anchor);
                    // 设置属性框的位置
                    let coord=overlay.get("overlayCoordinate")||feature.get("overlayCoordinate");
                    if(coord){
                        overlay.setPosition(coord);
                    }else{
                        coord=stationCoordinate;
                        overlay.setPosition(coord);
                        // 保存坐标，因为使用getPostion()方法无法获取overlay的坐标
                        overlay.set("overlayCoordinate",coord);
                    }
                    // 显示标签
                    overlayDom.style.display="block";
                    // 地图初始化完成之后执行绘制指向线的工作，否则不进行绘制
                    if(this.mapComplete){
                        // 获取属性框的宽高
                        offsetWidth=overlayDom.offsetWidth/2;
                        offsetHeight=overlayDom.offsetHeight/2;
                        // 获取最新坐标,绘制最新的连线
                        let stationPixel=map.getPixelFromCoordinate(stationCoordinate); // 站点的屏幕像素值
                        // 计算图标屏幕像素偏移量

                        // 计算图标顶点的坐标，也就是绘制的连线，应该指向图标的顶点
                        // 计算方法，也就是获取图标的旋转角度，获取站点原始坐标，图标的宽高为30x46
                        // 根据三角函数，已知斜边，求两个直角标的宽高，就可以使用sin和cos三角函数关系
                        let label=feature.get("label")||0;
                        let radian = 0; // 角度转弧度
                        let picOffsetX=0;
                        let picOffsetY=0;
                        switch(label){
                            case 0:
                                picOffsetX=0;
                                picOffsetY=25;
                                break;
                            case 90:
                                picOffsetX=25;
                                picOffsetY=0;
                                break;
                            case 180:
                                picOffsetX=0;
                                picOffsetY=-25;
                                break;
                            case 270:
                                picOffsetX=-25;
                                picOffsetY=0;
                                break;
                            default:
                                radian = label * (Math.PI/180); // 角度转弧度
                                picOffsetX=parseInt(25*Math.sin(radian));
                                picOffsetY=parseInt(25*Math.cos(radian));
                                break;
                        }
                        let labelPixel=[stationPixel[0]+picOffsetX,stationPixel[1]-picOffsetY];
                        let labelCoordinate=map.getCoordinateFromPixel(labelPixel);

                        if(coord&&labelCoordinate){
                            let overlayPixel=map.getPixelFromCoordinate(coord);
                            overlayPixel=[overlayPixel[0]+offset[0],overlayPixel[1]+offset[1]];
                            overlayPixel=that.calculateClosestPoint(overlayPixel,labelPixel,anchor,offsetWidth,offsetHeight); // 计算最新的屏幕像素位置

                            coord=map.getCoordinateFromPixel(overlayPixel);
                            // 绘制虚线,从overlay的基点位置，到图标的末点位置
                            let lineFeature = new Feature({
                                id:fid,
                                geometry: new LineString([coord,labelCoordinate])
                            });
                            lineFeature.setId(fid);
                            overlay.set("line",lineFeature);
                            linesource.addFeature(lineFeature);
                        }
                    }
                }else {
                    overlay.setPosition(undefined);
                    // 显示标签
                    overlayDom.style.display="none";
                }

                // feature和overlay进行绑定
                feature.set("overlay",overlay);
                // overlay显示之后获取到元素的实际高度
                offsetWidth=overlayDom.offsetWidth/2;
                offsetHeight=overlayDom.offsetHeight/2;

                //绑定事件,点击属性框，是当前属性框放到最前面,避免重复绑定
                if(!overlay.get("events")){
                    overlayDom.addEventListener("click",function () {
                        // 清除其他的面板
                        let ztOverlayWarpArray=this.parentNode.parentNode.querySelectorAll(".ztOverlayWarp");
                        ztOverlayWarpArray.forEach(item=>{
                            item.classList.remove("ztOverlayStick");
                        });
                        // 清除Dom引用
                        ztOverlayWarpArray=null;
                        // 设定当前面板最上面
                        this.parentNode.classList.add("ztOverlayStick");
                    });
                    // 设置标志位
                    overlay.set("events",true);
                }
                // 清除Dom引用，防止内存泄漏
                overlayDom=null;
            }
            // 站点属性加载完成之后，重新渲染连线
            this.mapRenderComplete();
        },
        // 显示overlay的连线
        showOverlayLine(){
            /**
             * 绘制连线的功能代码
             */
            let that=this;
            let map=this.mainmap;// 获取地图引用
            // 监听地图分辨率改变事件，重新计算指向线的起点位置
            let mapview=map.getView();
            // let features=this.stationFeatureArray;

            if(!that.overlayLineLayer){
                console.log("连线图层未定义");
                return;
            }

            let linesource=that.overlayLineLayer.getSource(); // 属性与图标的连线图层
            mapview.on("change:resolution",_debounce(()=>{
                linesource.clear(); //清空全部连线
                // 地图第一次渲染完成
                if(!that.mapComplete){
                    return;
                }
                // 重新执行站点属性信息显示
                this.stationPropertyShow();         
            },500));
        },
        // 地图渲染完成之后
        mapRenderComplete(){
            // 地图第一次渲染完成
            if(this.mapComplete){
                return;
            }
            
            if(!this.overlayLineLayer){
                console.log("连线图层未定义");
                return;
            }
             /**
             * 绘制连线的功能代码
             */
            let that=this;
            let map=this.mainmap;// 获取地图引用
            // let overlayers=map.getOverlays();
            let features=this.stationFeatureArray;

            let linesource=that.overlayLineLayer.getSource(); // 属性与图标的连线图层
             // 地图渲染完成之后，绘制第一条连线
            map.once("rendercomplete",function(){
                linesource.clear();// 清空已有连线
                // 遍历绘制连线
                features.forEach(feature=>{
                    let stationGeom=feature.getGeometry();
                    let stationCoordinate=stationGeom.getCoordinates(); // 站点坐标
                    let overlay=feature.get("overlay");
                     // 如果overlay不存在，不绘制相关的连线
                    if(!overlay){
                        return;
                    }
                    // 如果overlay的positing为undefine也不显示连线
                    let overlayDom=overlay.getElement();
                    if(!overlay.getPositioning()||overlayDom.style.display=="none"){
                        return;
                    }

                    // 计算图标顶点的坐标，也就是绘制的连线，应该指向图标的顶点
                    // 计算方法，也就是获取图标的旋转角度，获取站点原始坐标，图标的宽高为30x46
                    // 根据三角函数，已知斜边，求两个直角标的宽高，就可以使用sin和cos三角函数关系
                    let label=feature.get("label")||0;
                    let radian = 0; // 角度转弧度
                    let picOffsetX=0;
                    let picOffsetY=0;
                    switch(label){
                        case 0:
                            picOffsetX=0;
                            picOffsetY=25;
                            break;
                        case 90:
                            picOffsetX=25;
                            picOffsetY=0;
                            break;
                        case 180:
                            picOffsetX=0;
                            picOffsetY=-25;
                            break;
                        case 270:
                            picOffsetX=-25;
                            picOffsetY=0;
                            break;
                        default:
                            radian = label * (Math.PI/180); // 角度转弧度
                            picOffsetX=parseInt(25*Math.sin(radian));
                            picOffsetY=parseInt(25*Math.cos(radian));
                            break;
                    }
                    // 获取站点坐标的屏幕像素值,
                    // 这里有一个问题，就是当地图第一次加载的时候，会出现stationPixel计算不正确的问题
                    let stationPixel=map.getPixelFromCoordinate(stationCoordinate);
                    // 计算图标屏幕像素偏移量
                    stationPixel=[stationPixel[0]+picOffsetX,stationPixel[1]-picOffsetY];
                    let labelCoordinate=map.getCoordinateFromPixel(stationPixel);
                    overlay.set("labelCoordinate",labelCoordinate); // 也就是偏移点坐标

                    // 获取最新坐标,也就是overlayer的基点坐标
                    let coor=overlay.get("overlayCoordinate")||feature.get("overlayCoordinate");
                    if(coor){
                        let overlayPixel=map.getPixelFromCoordinate(coor);
                        let offset=overlay.getOffset(); //获取停靠点的偏移量
                        overlayPixel=[overlayPixel[0]+offset[0],overlayPixel[1]+offset[1]];
                        let labelPixel=map.getPixelFromCoordinate(labelCoordinate);// 获取label点的坐标值

                        // 获取属性框的宽高
                        let overlayDom=overlay.getElement();
                        let offsetWidth=overlayDom.offsetWidth/2;
                        let offsetHeight=overlayDom.offsetHeight/2;
                        let anchor=feature.get("anchor");
                        
                        overlayPixel=that.calculateClosestPoint(overlayPixel,labelPixel,anchor,offsetWidth,offsetHeight); // 计算最新的屏幕像素位置
                        coor=map.getCoordinateFromPixel(overlayPixel);
                        // 绘制虚线,从overlay的基点位置，到图标的末点位置
                        let fid="line"+feature.get("id");
                        let lineFeature = new Feature({
                            id:fid,
                            geometry: new LineString([coor,labelCoordinate])
                        });
                        lineFeature.setId(fid);

                        overlay.set("line",lineFeature);
                        linesource.addFeature(lineFeature);
                    }
                });
                // 绑定鼠标移动overlay事件
                // that.dragPanOverlay();

                // 地图渲染完成
                that.mapComplete=true;
            });
        },
        /** 计算最近停靠点
         * overlaydatum 基准点
         * anchor 停靠方式
         * offsetWidth 面板宽度
         * offsetHeith 面板长度
         */
        calculateClosestPoint(overlaydatum,labeldatum,anchor,offsetWidth,offsetHeight){
            let x1=overlaydatum[0];
            let x2=overlaydatum[0];
            let x3=overlaydatum[0];
            let y1=overlaydatum[1];
            let y2=overlaydatum[1];
            let y3=overlaydatum[1];
            switch (anchor) {
                case "bottom-left":
                    x1=overlaydatum[0];
                    x2=overlaydatum[0]+offsetWidth;
                    x3=overlaydatum[0]+2*offsetWidth;
                    y1=overlaydatum[1]-2*offsetHeight;
                    y2=overlaydatum[1]-offsetHeight;
                    y3=overlaydatum[1];
                    break;
                case "bottom-center":
                    x1=overlaydatum[0]-offsetWidth;
                    x2=overlaydatum[0];
                    x3=overlaydatum[0]+offsetWidth;
                    y1=overlaydatum[1]-2*offsetHeight;
                    y2=overlaydatum[1]-offsetHeight;
                    y3=overlaydatum[1];
                    break;
                case "bottom-right":
                    x1=overlaydatum[0]-2*offsetWidth;
                    x2=overlaydatum[0]-offsetWidth;
                    x3=overlaydatum[0];
                    y1=overlaydatum[1]-2*offsetHeight;
                    y2=overlaydatum[1]-offsetHeight;
                    y3=overlaydatum[1];
                    break;
                case "center-left":
                    x1=overlaydatum[0];
                    x2=overlaydatum[0]+offsetWidth;
                    x3=overlaydatum[0]+2*offsetWidth;
                    y1=overlaydatum[1]-offsetHeight;
                    y2=overlaydatum[1];
                    y3=overlaydatum[1]+offsetHeight;
                    break;
                case "center-center":
                    x1=overlaydatum[0]-offsetWidth;
                    x2=overlaydatum[0];
                    x3=overlaydatum[0]+offsetWidth;
                    y1=overlaydatum[1]-offsetHeight;
                    y2=overlaydatum[1];
                    y3=overlaydatum[1]+offsetHeight;
                    break;
                case "center-right":
                    x1=overlaydatum[0]-2*offsetWidth;
                    x2=overlaydatum[0]-offsetWidth;
                    x3=overlaydatum[0];
                    y1=overlaydatum[1]-offsetHeight;
                    y2=overlaydatum[1];
                    y3=overlaydatum[1]+offsetHeight;
                    break;
                case "top-left":
                    x1=overlaydatum[0];
                    x2=overlaydatum[0]+offsetWidth;
                    x3=overlaydatum[0]+2*offsetWidth;
                    y1=overlaydatum[1];
                    y2=overlaydatum[1]+offsetHeight;
                    y3=overlaydatum[1]+2*offsetHeight;
                    break;
                case "top-center":
                    x1=overlaydatum[0]-offsetWidth;
                    x2=overlaydatum[0];
                    x3=overlaydatum[0]+offsetWidth;
                    y1=overlaydatum[1];
                    y2=overlaydatum[1]+offsetHeight;
                    y3=overlaydatum[1]+2*offsetHeight;
                    break;
                case "top-right":
                    x1=overlaydatum[0]-2*offsetWidth;
                    x2=overlaydatum[0]-offsetWidth;
                    x3=overlaydatum[0];
                    y1=overlaydatum[1];
                    y2=overlaydatum[1]+offsetHeight;
                    y3=overlaydatum[1]+2*offsetHeight;
                    break;
            }
            // 求最靠近label的x位置
            if(labeldatum[0]<=x1){
                overlaydatum[0]=x1;
            }else if(labeldatum[0]>=x3){
                overlaydatum[0]=x3;
            }else if(labeldatum[0]>x1&&labeldatum[0]<x3){
                overlaydatum[0]=x2;
            }
            // 求最靠近label的y位置
            if(labeldatum[1]<=y1){
                overlaydatum[1]=y1;
            }else if(labeldatum[1]>=y3){
                overlaydatum[1]=y3;
            }else if(labeldatum[1]>y1&&labeldatum[1]<y3){
                overlaydatum[1]=y2;
            }
            return overlaydatum;
        },
    }    
}
</script>

<style lang="scss">
.sitepanel{
    position:absolute;
    z-index: 1;
    right: 10px;
    top:70px;

    .btn-setting{
        margin-bottom: 10px;

        cursor: pointer;

        img{
            width: 40px;
            height: 40px;
        }
    }
    /*站点的关闭和隐藏*/
    .btn-setting-label{
        background: #EFEFEF;
        border-radius: 20px;
    }
    .btn-setting-label img{
        z-index: 10;
        position: relative;
        right: 0;
    }
    .label-subitem{
        position: absolute;
        top:0px;
        right: 0;
        background: #EFEFEF;
        padding:0px 50px 0px 10px;
        line-height: 30px;
        z-index: 1;
        border-radius: 20px;
        color:#999999;
        font-size:11px;
        display: flex;
    }
    .label-subitem .item{
        cursor: pointer;
        margin: 5px;
        word-break: keep-all;
    }
    .label-subitem .selected{
        color:#2285FF;
    }
    /** 站点显示隐藏样式结束 */

}
/*站点配置*/
.station-wrapper{
    border-radius: 20px;
    overflow: hidden;

    .setting-conent .setting-item{
        flex-wrap:wrap;
        display: flex;
        flex-direction: row;
        justify-content: left;
        margin-top: 5px
    }
    .setting-conent .setting-item:after {
        content: "";
        flex: auto;
    }
    .setting-conent .setting-item .item{
        padding:10px 20px;
        font-size:15px;
        cursor: pointer;
        border-radius: 5px;
        margin:5px;
        border:1px solid #E3E3E3;
        cursor: pointer;
        position:relative;
    }
    .setting-conent .setting-item .item.selected{
        border:1px solid #3086FF;
    }
    .setting-conent .setting-item .item.selected:after{
        content:"";
        content: url(../../assets/img/btn-selected.png);
        position:absolute;
        left: 0;
        bottom:-4px;
    }

    .btn{
        width: 100%;
        height: 50px;
        border: none;
        cursor: pointer;
    }
    .btn-ok{
        background:#3086FF;
        color:#fff;
    }

    .current-medium{
        font-size: 12px;
        color:red;
    }

    /**重定义element-ui的样式 */
    .el-dialog__header{
        padding:10px;
    }
    .el-dialog__body{
        padding:0 20px;
    }
    .el-dialog__footer{
        padding:10px 0 0 0;
    }
    .el-button{
        margin-left: 0;

        span{
            cursor: pointer;
        }
    }
}
/*站点配置*/

/** 站点属性 */
.ztOverlay{
    background-color:rgba(255,255,255,0.8);
    border-radius: 4px;
    font-size:12px;
    box-shadow: 0 0 5px rgba(0,0,0,0.6);
    position: relative;

    /* 禁止文字被鼠标选中  */
    -moz-user-select: -moz-none; 
    -moz-user-select: none; 
    -o-user-select:none; 
    -khtml-user-select:none; 
    -webkit-user-select:none; 
    -ms-user-select:none; 
    user-select:none;

    display: none;
}

.ztOverlay .zt-title{
    overflow: hidden;
    // zoom:1;
    font-size:14px;
    padding:7px 7px 0;
}


/* 箭头 */
.ztOverlay.pipelineproperty::after{
    content:"";
    position:absolute;
    left: 50%;
    transform: translateX(-50%);
    width:0px;
    height:0px;
    bottom: -10px;
    border-top: 10px solid rgba(255,255,255,0.8);
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
}



.ztOverlay .zt-title span{
    white-space: nowrap;
}
.ztOverlay .zt-close{
    float: right;
    cursor: pointer;
}
.ztOverlay .ztOverlay_content{
    padding:0 10px 10px;
    width:100%;
    white-space:nowrap;
    overflow: hidden;
    position: relative;
}
.ztOverlay .ztOverlay_content li{
    overflow: hidden;
    zoom: 1;
    position: relative;
}
.ztOverlay .ztOverlay_content .datavalue{
    display: inline-block;
    vertical-align: text-top;
}

.ztOverlayStick{
    z-index: 10000;
}
.ztOverlay .ztOverlay_content li .filedname{
    position: relative;
    display: inline-block;
    text-align: left;
    flex-basis: content;
}
/** 站点属性 */

.ztOverlay.pipelineproperty{
    .zt-title{
        position: absolute;
        right:-15px;
        top:-15px;
        border-radius: 20px;
        padding:5px;
        background-color:rgba(255,255,255,0.8);
    }

    .ztOverlay_content{
        padding:10px;
    }
}
</style>